import icon from '@/img/constructor/icon-pencil.svg';
export default function EditPencilIcon() {
  return <img src={icon} alt="" style={{ marginBottom: '-3px', height: '20px' }} />;
}
